import {
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { generatePath } from "react-router-dom";
import NavigationTabs, {
  NavigationTabDefinition,
} from "../components/NavigationTabs";
import { useParams } from "../util";
import { Service } from "../_generated";
import styles from "./InfoTable.module.css";
import { useResource } from "../useResource";
import API from "../api";
import ServiceEditDialog from "./ServiceEditDialog";
import moment from "moment";
import { Alert } from "@material-ui/lab";
import analytics from "../analytics";

export const servicePagePath =
  "/projects/:project_name/services/:service_id/:tab?";

export default function ServicePage() {
  const { project_name, service_id, tab } = useParams(servicePagePath);
  const [service] = useResource(API.services.read, service_id, project_name);

  // // API polling
  // useEffect(() => {
  //   const handle = setInterval(refresh, 3000, true);
  //   return () => clearInterval(handle);
  // }, [refresh]);

  const tabs: NavigationTabDefinition[] = [
    {
      id: "info",
      label: "Info",
      page: <ServiceInfo service={service} projectName={project_name} />,
    },
    // {
    //   id: "configuration",
    //   label: "Configuration",
    //   page: <ServiceConfigPage projectName={project_name} service={service} />,
    // },
    {
      id: "activity",
      label: "Activity (soon)",
      page: <div>Activity</div>,
      disabled: true,
    },
  ];

  return (
    <NavigationTabs
      basePath={generatePath(servicePagePath, {
        project_name,
        service_id,
      })}
      tabs={tabs}
      currentTabID={tab}
    />
  );
}

function ServiceInfo({
  service,
  projectName,
}: {
  service: Service;
  projectName: string;
}) {
  const [showEditDialog, setShowEditDialog] = useState(false);

  function onServiceUpdate(service: Service) {
    API.services.update(String(service.pk), projectName, service);
    setShowEditDialog(false);
  }

  useEffect(() => {
    analytics.page("ServiceInfo");
  }, []);

  return (
    <>
      <Grid container justify="center">
        <Grid item>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6">
                {service.alias || service.name}
              </Typography>
              <table className={styles.infoTable}>
                <tbody>
                  <tr>
                    <th>ID:</th>
                    <td>{service.name}</td>
                  </tr>
                  <tr>
                    <th>Service Type:</th>
                    <td>{service.service_type}</td>
                  </tr>
                  <tr>
                    <th>Repository:</th>
                    <td>{service.repository}</td>
                  </tr>
                  <tr>
                    <th>Dockerfile:</th>
                    <td>{service.dockerfile}</td>
                  </tr>
                  <tr>
                    <th>Health check:</th>
                    <td>{service.health_check}</td>
                  </tr>
                  <tr>
                    <th>Container port:</th>
                    <td>{service.container_port}</td>
                  </tr>
                  <tr>
                    <th>Created:</th>
                    <td>
                      {service.date_created
                        ? moment(service.date_updated).toLocaleString()
                        : "never"}
                    </td>
                  </tr>
                  <tr>
                    <th>Last updated:</th>
                    <td>
                      {service.date_updated
                        ? moment(service.date_updated).toLocaleString()
                        : "never"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardContent>
            <CardActions>
              <Grid container>
                <Grid item xs={12}>
                  <Alert severity="info">
                    Go to Environments to see URL of each service in each
                    environment
                  </Alert>
                </Grid>
              </Grid>
            </CardActions>
          </Card>
        </Grid>
      </Grid>

      <ServiceEditDialog
        open={showEditDialog}
        service={service}
        onSubmit={onServiceUpdate}
        onCancel={() => setShowEditDialog(false)}
      />
    </>
  );
}
